import { GetProjectAlertEmails } from '@/connection/emails/project-alert-emails';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const getProjectAlertEmailsReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: number }, { rejectWithValue }) => {
      try {
        const results = await GetProjectAlertEmails({ channel });

        return results;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.projectAlertEmails = action.payload;
      },
    }
  );
};

export default getProjectAlertEmailsReducer;
